import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LOGO, NavBar, FB_URL, IG_URL, WHATSAPP, RECEPTION_WHATSAPP, BANK, ADDRESS } from "../shared";


// ─── YOUR KITCHEN WHATSAPP NUMBER ─────────────────────────────────────────────
// Replace this with your real WhatsApp number (include country code, no +)

// ─── FULL MENU DATA ────────────────────────────────────────────────────────────
const MENU_CATEGORIES = [
  {
    id: "breakfast", label: "Breakfast", icon: "🌅", hours: "6AM – 11AM", color: "#e8963a",
    items: [
      { id: "b1", name: "Tea + Bread + Egg", price: 4500, emoji: "🍳" },
      { id: "b2", name: "Coffee + Sandwich", price: 5000, emoji: "☕" },
      { id: "b3", name: "Indomie + 2 Eggs", price: 4500, emoji: "🍜", tag: "Popular" },
      { id: "b4", name: "Yam + Egg Sauce", price: 6000, emoji: "🥚" },
      { id: "b5", name: "Pap + Akara", price: 4000, emoji: "🫕" },
      { id: "b6", name: "Bread + Omelette", price: 5000, emoji: "🍞" },
      { id: "b7", name: "Full Breakfast", price: 7500, emoji: "🍽️", tag: "Best Value", desc: "Tea, Bread, Egg, Sausage" },
    ],
  },
  {
    id: "lunch", label: "Lunch & Dinner", icon: "🍛", hours: "12PM – 10PM", color: "#c8860a",
    items: [
      { id: "l1", name: "Jollof Rice + Chicken", price: 7500, emoji: "🍗", tag: "🔥 Bestseller" },
      { id: "l2", name: "Fried Rice + Turkey", price: 8500, emoji: "🦃", tag: "🔥 Bestseller" },
      { id: "l3", name: "White Rice + Stew + Beef", price: 7000, emoji: "🍖" },
      { id: "l4", name: "Spaghetti + Chicken", price: 7000, emoji: "🍝" },
      { id: "l5", name: "Beans + Plantain", price: 6000, emoji: "🌿" },
      { id: "l6", name: "Pounded Yam + Egusi + Beef", price: 9500, emoji: "🫙" },
      { id: "l7", name: "Semo + Okra + Fish", price: 9000, emoji: "🐟" },
      { id: "l8", name: "Native Rice + Chicken", price: 8500, emoji: "🍚" },
    ],
  },
  {
    id: "specials", label: "401 Specials", icon: "🌶️", hours: "Fri – Sun", color: "#e03a2e",
    items: [
      { id: "s1", name: "Yam + Chicken", price: 8500, emoji: "🍗" },
      { id: "s2", name: "Goat Meat Pepper Soup", price: 10000, emoji: "🌶️", tag: "🔥 Bestseller" },
      { id: "s3", name: "Catfish Pepper Soup", price: 12000, emoji: "🐟" },
      { id: "s4", name: "Isi Ewu", price: 15000, emoji: "🐐", tag: "Premium" },
      { id: "s5", name: "Suya Platter + Fries", price: 12000, emoji: "🔥", tag: "Popular" },
      { id: "s6", name: "Grilled Fish + Plantain", price: 15000, emoji: "🎣", tag: "Premium" },
    ],
  },
  {
    id: "fastbites", label: "Quick Bites", icon: "🍔", hours: "All day", color: "#d4a017",
    items: [
      { id: "f1", name: "Shawarma", price: 6500, emoji: "🌯", tag: "🔥 Bestseller" },
      { id: "f2", name: "Chicken & Chips", price: 8000, emoji: "🍟" },
      { id: "f3", name: "Burger + Fries", price: 8500, emoji: "🍔", tag: "Popular" },
      { id: "f4", name: "Meat Pie", price: 3000, emoji: "🥧" },
      { id: "f5", name: "Small Chops", price: 6000, emoji: "🍢" },
      { id: "f6", name: "French Fries", price: 5000, emoji: "🍟" },
    ],
  },
  {
    id: "midnight", label: "Midnight", icon: "🌙", hours: "10PM – 2AM", color: "#5b4fcf",
    items: [
      { id: "m1", name: "Indomie Special + Egg", price: 5500, emoji: "🍜" },
      { id: "m2", name: "Pepper Soup", price: 10000, emoji: "🌶️", tag: "Popular" },
      { id: "m3", name: "Shawarma", price: 7000, emoji: "🌯" },
      { id: "m4", name: "Fries + Chicken Wings", price: 8500, emoji: "🍗" },
      { id: "m5", name: "Tea / Coffee", price: 3500, emoji: "☕" },
    ],
  },
  {
    id: "drinks", label: "Drinks", icon: "🍹", hours: "All day", color: "#2e9e6e",
    items: [
      { id: "d1", name: "Water", price: 1000, emoji: "💧" },
      { id: "d2", name: "Soft Drink", price: 1500, emoji: "🥤" },
      { id: "d3", name: "Malt", price: 2000, emoji: "🧃" },
      { id: "d4", name: "Juice", price: 2500, emoji: "🍊" },
      { id: "d5", name: "Energy Drink", price: 3000, emoji: "⚡" },
      { id: "d6", name: "Fresh Juice", price: 4500, emoji: "🍹", tag: "Premium" },
    ],
  },
  {
    id: "bar", label: "Bar", icon: "🍺", hours: "Evening", color: "#b5860a",
    items: [
      { id: "br1", name: "Beer (Regular)", price: 3500, emoji: "🍺" },
      { id: "br2", name: "Premium Beer", price: 4500, emoji: "🍻" },
      { id: "br3", name: "Wine (Glass)", price: 5000, emoji: "🍷" },
      { id: "br4", name: "Wine (Full Bottle)", price: 18000, emoji: "🍾", tag: "Premium" },
      { id: "br5", name: "Whiskey Shot", price: 5000, emoji: "🥃" },
    ],
  },
];

const COMBOS = [
  { id: "c1", name: "Jollof Combo", desc: "Jollof Rice + Chicken + Drink", price: 9500, saving: 500, emoji: "🍗" },
  { id: "c2", name: "Breakfast Combo", desc: "Full Breakfast + Tea/Coffee", price: 6500, saving: 1000, emoji: "🌅" },
  { id: "c3", name: "Pepper Soup Special", desc: "Pepper Soup + Drink", price: 12000, saving: 500, emoji: "🌶️" },
  { id: "c4", name: "Burger Deal", desc: "Burger + Fries + Drink", price: 10000, saving: 500, emoji: "🍔" },
];

const BESTSELLERS = ["l1", "l2", "s2", "f1", "b7"];

const fmt = (n) => "₦" + Number(n).toLocaleString();

// ─── WHATSAPP MESSAGE BUILDER ──────────────────────────────────────────────────
function buildWhatsAppMessage({ orderNum, orderType, cart, form, grandTotal, allItems }) {
  const now = new Date();
  const time = now.toLocaleTimeString("en-NG", { hour: "2-digit", minute: "2-digit" });
  const date = now.toLocaleDateString("en-NG", { weekday: "short", day: "numeric", month: "short" });

  const itemLines = cart.map((c) => {
    const item = allItems.find((i) => i.id === c.id);
    return `  • ${item?.name || c.name} x${c.qty} — ${fmt(c.price * c.qty)}`;
  }).join("\n");

  const typeEmoji = orderType === "room" ? "🛎️" : orderType === "pickup" ? "🏃" : "🛵";
  const typeLabel = orderType === "room" ? "ROOM SERVICE" : orderType === "pickup" ? "PICKUP" : "DELIVERY";

  let details = "";
  if (orderType === "room") details = `🏨 Room: ${form.room}\n👤 Guest: ${form.name}`;
  if (orderType === "pickup") details = `👤 Name: ${form.name}\n📞 Phone: ${form.phone}\n⏰ Pickup: ${form.pickup || "ASAP"}`;
  if (orderType === "delivery") details = `👤 Name: ${form.name}\n📞 Phone: ${form.phone}\n📍 Address: ${form.address}`;

  return `🍽️ *NEW ORDER — THE 401 HOTEL & SUITES LTD*
━━━━━━━━━━━━━━━━━━
🔖 Order: *${orderNum}*
🕐 Time: ${time} · ${date}
${typeEmoji} Type: *${typeLabel}*
━━━━━━━━━━━━━━━━━━
📋 *ITEMS ORDERED:*
${itemLines}
━━━━━━━━━━━━━━━━━━
💰 *TOTAL: ${fmt(grandTotal)}*
💳 Payment: ${form.payment}
━━━━━━━━━━━━━━━━━━
📌 *CUSTOMER DETAILS:*
${details}
━━━━━━━━━━━━━━━━━━
Please confirm & prepare. Reply DONE when ready.`;
}

// ─── MAIN APP ──────────────────────────────────────────────────────────────────
export default function FoodOrder() {
  const navigate = useNavigate();
  const [page, setPage] = useState("home");
  const [orderType, setOrderType] = useState(null);
  const [activeCat, setActiveCat] = useState("breakfast");
  const [cart, setCart] = useState([]);
  const [form, setForm] = useState({ room: "", name: "", phone: "", address: "", pickup: "", payment: "" });
  const [orderNum] = useState(() => "401-" + Math.floor(1000 + Math.random() * 9000));
  const [sending, setSending] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [pendingItem, setPendingItem] = useState(null);

  const allItems = MENU_CATEGORIES.flatMap((c) => c.items);
  const cartEntry = (id) => cart.find((c) => c.id === id);
  const cartCount = cart.reduce((a, c) => a + c.qty, 0);
  const cartTotal = cart.reduce((a, c) => a + c.price * c.qty, 0);
  const deliveryFee = orderType === "delivery" ? 500 : 0;
  const grandTotal = cartTotal + deliveryFee;

  const quickAdd = (item) => {
    if (!orderType) {
      setPendingItem(item);
      setShowModal(true);
    } else {
      addItem(item);
      setPage("cart");
    }
  };

  const selectTypeAndAdd = (type) => {
    setOrderType(type);
    setShowModal(false);
    if (pendingItem) {
      addItem(pendingItem);
      setPendingItem(null);
    }
    setPage("cart");
  };

  const addItem = (item) =>
    setCart((prev) => {
      const ex = prev.find((c) => c.id === item.id);
      return ex ? prev.map((c) => c.id === item.id ? { ...c, qty: c.qty + 1 } : c)
        : [...prev, { id: item.id, name: item.name, price: item.price, qty: 1 }];
    });

  const removeItem = (id) =>
    setCart((prev) => {
      const ex = prev.find((c) => c.id === id);
      return ex?.qty > 1 ? prev.map((c) => c.id === id ? { ...c, qty: c.qty - 1 } : c)
        : prev.filter((c) => c.id !== id);
    });

  const sendToWhatsApp = () => {
    setSending(true);
    const msg = buildWhatsAppMessage({ orderNum, orderType, cart, form, grandTotal, allItems });
    const url = `https://wa.me/${KITCHEN_WHATSAPP}?text=${encodeURIComponent(msg)}`;
    setTimeout(() => {
      window.open(url, "_blank");
      setSending(false);
      setPage("confirm");
    }, 800);
  };

  // ── Colors ────────────────────────────────────────────────────────────────────
  const C = {
    bg: "#0a0702", surface: "#120d04", card: "#1a1206", border: "#2a1e08",
    gold: "#c8860a", goldLight: "#e8a020", goldDim: "#7a5206",
    cream: "#f0e4c8", muted: "#8a7050", danger: "#e03a2e", green: "#3aad72", purple: "#7b6fd4",
  };

  const base = { fontFamily: "'Palatino Linotype','Book Antiqua',Palatino,Georgia,serif", background: C.bg, minHeight: "100vh", color: C.cream, maxWidth: "100%", margin: "0 auto", position: "relative" };

  // ── Shared styles ─────────────────────────────────────────────────────────────
  const goldBtn = { display: "block", width: "100%", background: `linear-gradient(135deg,${C.gold},${C.goldLight})`, border: "none", borderRadius: 12, padding: "15px", fontSize: 15, fontWeight: "bold", color: C.bg, cursor: "pointer", letterSpacing: 1, fontFamily: "inherit" };
  const secLabel = { fontSize: 10, letterSpacing: 3, color: C.gold, display: "block", marginBottom: 16 };
  const formInput = { width: "100%", background: C.card, border: `1px solid ${C.border}`, borderRadius: 10, padding: "12px 14px", color: C.cream, fontSize: 14, fontFamily: "inherit", marginBottom: 16, boxSizing: "border-box", outline: "none" };
  const formLabel = { display: "block", fontSize: 10, letterSpacing: 2, color: C.gold, marginBottom: 6 };

  // ── HOME ──────────────────────────────────────────────────────────────────────
  const renderHome = () => {
    const bsItems = BESTSELLERS.map((id) => allItems.find((i) => i.id === id)).filter(Boolean);
    return (
      <div>
        <div style={{ background: `linear-gradient(170deg,#1e1200 0%,${C.bg} 100%)`, padding: "36px 22px 28px", textAlign: "center", borderBottom: `1px solid ${C.border}` }}>
          <div style={{ display: "inline-block", border: `1px solid ${C.goldDim}`, color: C.gold, padding: "3px 14px", borderRadius: 20, fontSize: 10, letterSpacing: 3, marginBottom: 18 }}>THE 401 HOTEL & SUITES LTD</div>
          <h1 style={{ fontFamily: "inherit", fontSize: 36, fontWeight: "bold", color: C.cream, margin: "0 0 6px", lineHeight: 1.05, letterSpacing: 1 }}>401 Express<br />Kitchen</h1>
          <p style={{ color: C.muted, fontSize: 13, margin: "0 0 28px", letterSpacing: 1 }}>Quiet. Private. Professional. Serenity.</p>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {[
              { type: "room", icon: "🛎️", name: "Room Service", desc: "Delivered straight to your room" },
              { type: "pickup", icon: "🏃", name: "Pickup", desc: "Order now, collect at the kitchen" },
              { type: "delivery", icon: "🛵", name: "Delivery", desc: "We bring it to your doorstep" },
            ].map(({ type, icon, name, desc }) => (
              <button key={type}
                onClick={() => setOrderType(type)}
                style={{ background: orderType === type ? `${C.gold}18` : C.card, border: `2px solid ${orderType === type ? C.gold : C.border}`, borderRadius: 14, padding: "15px 18px", color: C.cream, cursor: "pointer", display: "flex", alignItems: "center", gap: 14, transition: "all 0.18s", textAlign: "left" }}>
                <span style={{ fontSize: 30 }}>{icon}</span>
                <span style={{ flex: 1 }}>
                  <span style={{ display: "block", fontWeight: "bold", fontSize: 15, color: orderType === type ? C.gold : C.cream }}>{name}</span>
                  <span style={{ display: "block", fontSize: 12, color: C.muted, marginTop: 3 }}>{desc}</span>
                </span>
                {orderType === type && <span style={{ color: C.gold, fontSize: 18 }}>✓</span>}
              </button>
            ))}
          </div>
          {orderType && <button style={{ ...goldBtn, marginTop: 20 }} onClick={() => setPage("menu")}>Browse Menu →</button>}
        </div>

        {/* Combos */}
        <div style={{ background: C.surface, borderTop: `1px solid ${C.border}`, borderBottom: `1px solid ${C.border}`, padding: 20 }}>
          <span style={secLabel}>🔥 COMBO DEALS — BEST VALUE</span>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 12 }}>
            {COMBOS.map((combo) => (
              <div key={combo.id} onClick={() => quickAdd({ id: combo.id, name: combo.name, price: combo.price })}
                style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 12, padding: "14px 16px", cursor: "pointer" }}>
                <span style={{ fontSize: 26, display: "block", marginBottom: 8 }}>{combo.emoji}</span>
                <span style={{ fontSize: 13, fontWeight: "bold", color: C.cream, display: "block" }}>{combo.name}</span>
                <span style={{ fontSize: 11, color: C.muted, display: "block", marginTop: 3, marginBottom: 8 }}>{combo.desc}</span>
                <span style={{ fontSize: 16, color: C.gold, fontWeight: "bold", display: "block" }}>{fmt(combo.price)}</span>
                <span style={{ fontSize: 10, color: C.green, display: "block", marginTop: 3 }}>Save {fmt(combo.saving)}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Bestsellers */}
        <div style={{ padding: "20px 20px 0" }}>
          <span style={secLabel}>⭐ DAILY BESTSELLERS</span>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: 12 }}>
            {bsItems.map((item) => (
              <div key={item.id} onClick={() => quickAdd(item)}
                style={{ background: C.card, border: `1px solid ${C.gold}33`, borderRadius: 12, padding: 14, cursor: "pointer", textAlign: "center" }}>
                <div style={{ fontSize: 28, marginBottom: 8 }}>{item.emoji}</div>
                <div style={{ fontSize: 12, color: C.cream, fontWeight: "bold", marginBottom: 6, lineHeight: 1.3 }}>{item.name}</div>
                <div style={{ fontSize: 14, color: C.gold, fontWeight: "bold" }}>{fmt(item.price)}</div>
              </div>
            ))}
          </div>
        </div>
        <div style={{ padding: "18px 20px", textAlign: "center" }}>
          <p style={{ color: C.muted, fontSize: 11, letterSpacing: 1, lineHeight: 1.8 }}>🌙 MIDNIGHT MENU · 10PM – 2AM<br />Noodles · Shawarma · Pepper Soup · Drinks</p>
        </div>

        {/* Social & Address Footer */}
        <div style={{ padding: "16px 20px 24px", borderTop: `1px solid ${C.border}`, textAlign: "center" }}>
          <div style={{ display: "flex", justifyContent: "center", gap: 16, marginBottom: 12 }}>
            <a href="https://instagram.com/the401hotel" target="_blank" rel="noreferrer"
              style={{ display: "flex", alignItems: "center", gap: 6, color: C.gold, fontSize: 12, textDecoration: "none", fontFamily: "inherit" }}>
              <span style={{ fontSize: 16 }}>📸</span> @the401hotel
            </a>
            <a href="https://www.facebook.com/share/1EJKkvzsNL/" target="_blank" rel="noreferrer"
              style={{ display: "flex", alignItems: "center", gap: 6, color: C.gold, fontSize: 12, textDecoration: "none", fontFamily: "inherit" }}>
              <span style={{ fontSize: 16 }}>📘</span> The 401 Hotel
            </a>
          </div>
          <p style={{ color: C.muted, fontSize: 10, letterSpacing: 1, lineHeight: 1.8, margin: 0 }}>
            Plot A/39 Iyiagu Estate, Off Abakaliki Street<br />Awka, Anambra State · the401homes.com
          </p>
        </div>
      </div>
    );
  };

  // ── MENU ──────────────────────────────────────────────────────────────────────
  const renderMenu = () => {
    const cat = MENU_CATEGORIES.find((c) => c.id === activeCat);
    return (
      <div>
        <div style={{ display: "flex", flexWrap: "wrap", background: C.surface, borderBottom: `1px solid ${C.border}`, padding: "0 4px" }}>
          {MENU_CATEGORIES.map((c) => (
            <button key={c.id}
              onClick={() => setActiveCat(c.id)}
              style={{ padding: "12px 14px", border: "none", background: "transparent", color: activeCat === c.id ? (c.color || C.gold) : C.muted, fontFamily: "inherit", fontSize: 11, fontWeight: activeCat === c.id ? "bold" : "normal", cursor: "pointer", whiteSpace: "nowrap", borderBottom: activeCat === c.id ? `2px solid ${c.color || C.gold}` : "2px solid transparent", letterSpacing: 1 }}>
              {c.icon} {c.label}
            </button>
          ))}
        </div>
        <div style={{ background: C.card, padding: "8px 20px", fontSize: 10, color: C.muted, letterSpacing: 2, borderBottom: `1px solid ${C.border}` }}>
          {cat.icon} {cat.label.toUpperCase()} · {cat.hours}
        </div>
        <div style={{ padding: "12px 18px" }}>
          {cat.items.map((item) => {
            const inCart = cartEntry(item.id);
            const tagColors = { "🔥 Bestseller": C.danger, "Popular": C.goldDim, "Best Value": C.green, "Premium": C.purple };
            const tagColor = tagColors[item.tag];
            return (
              <div key={item.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "13px 0", borderBottom: `1px solid ${C.border}33` }}>
                <div style={{ width: 48, height: 48, background: cat.color + "15", border: `1px solid ${cat.color}33`, borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, flexShrink: 0 }}>{item.emoji}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 14, color: C.cream, fontWeight: "500", marginBottom: 2 }}>{item.name}</div>
                  {item.desc && <div style={{ fontSize: 11, color: C.muted, marginBottom: 4 }}>{item.desc}</div>}
                  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <span style={{ fontSize: 15, color: C.gold, fontWeight: "bold" }}>{fmt(item.price)}</span>
                    {item.tag && <span style={{ fontSize: 9, background: tagColor + "22", border: `1px solid ${tagColor}66`, color: tagColor, padding: "2px 7px", borderRadius: 8, letterSpacing: 1 }}>{item.tag}</span>}
                  </div>
                </div>
                {inCart ? (
                  <div style={{ display: "flex", alignItems: "center", gap: 7, flexShrink: 0 }}>
                    <button onClick={() => removeItem(item.id)} style={{ width: 28, height: 28, border: `1px solid ${C.border}`, borderRadius: 6, background: C.card, color: C.gold, fontSize: 18, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>−</button>
                    <span style={{ color: C.cream, fontWeight: "bold", fontSize: 14, minWidth: 18, textAlign: "center" }}>{inCart.qty}</span>
                    <button onClick={() => addItem(item)} style={{ width: 28, height: 28, border: `1px solid ${C.gold}`, borderRadius: 6, background: C.gold, color: C.bg, fontSize: 18, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>+</button>
                  </div>
                ) : (
                  <button onClick={() => addItem(item)} style={{ width: 32, height: 32, border: `1px solid ${C.gold}`, borderRadius: 8, background: C.gold, color: C.bg, fontSize: 20, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold", flexShrink: 0 }}>+</button>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  // ── CART ──────────────────────────────────────────────────────────────────────
  const renderCart = () => (
    <div style={{ padding: "20px 18px" }}>
      <span style={secLabel}>YOUR ORDER</span>
      {cart.length === 0 ? (
        <p style={{ color: C.muted, textAlign: "center", marginTop: 40 }}>Your cart is empty. Add items from the menu.</p>
      ) : (
        <>
          {cart.map((c) => {
            const item = allItems.find((i) => i.id === c.id) || c;
            return (
              <div key={c.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "13px 0", borderBottom: `1px solid ${C.border}33` }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 14, color: C.cream }}>{c.name}</div>
                  <div style={{ fontSize: 12, color: C.muted, marginTop: 2 }}>{fmt(c.price)} × {c.qty}</div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
                  <button onClick={() => removeItem(c.id)} style={{ width: 28, height: 28, border: `1px solid ${C.border}`, borderRadius: 6, background: C.card, color: C.gold, fontSize: 18, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>−</button>
                  <span style={{ color: C.cream, fontWeight: "bold", fontSize: 14, minWidth: 18, textAlign: "center" }}>{c.qty}</span>
                  <button onClick={() => addItem({ ...item, id: c.id, name: c.name, price: c.price })} style={{ width: 28, height: 28, border: `1px solid ${C.gold}`, borderRadius: 6, background: C.gold, color: C.bg, fontSize: 18, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>+</button>
                </div>
                <div style={{ color: C.gold, fontWeight: "bold", fontSize: 14, minWidth: 72, textAlign: "right" }}>{fmt(c.price * c.qty)}</div>
              </div>
            );
          })}
          <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 14, padding: "16px 18px", marginTop: 16 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8, fontSize: 13 }}>
              <span style={{ color: C.muted }}>Subtotal ({cartCount} items)</span><span>{fmt(cartTotal)}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13 }}>
              <span style={{ color: C.muted }}>{orderType === "delivery" ? "Delivery Fee" : "Service Charge"}</span>
              <span style={{ color: orderType === "delivery" ? C.cream : C.green }}>{orderType === "delivery" ? fmt(500) : "Free"}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", borderTop: `1px solid ${C.border}`, paddingTop: 12, marginTop: 10 }}>
              <span style={{ fontWeight: "bold", fontSize: 16 }}>Total</span>
              <span style={{ fontWeight: "bold", fontSize: 20, color: C.gold }}>{fmt(grandTotal)}</span>
            </div>
          </div>
          <button style={{ ...goldBtn, marginTop: 16 }} onClick={() => setPage("checkout")}>Proceed to Checkout →</button>
          <button onClick={() => setPage("menu")} style={{ display: "block", width: "100%", marginTop: 10, background: "transparent", border: `1px solid ${C.border}`, borderRadius: 10, padding: 12, color: C.muted, cursor: "pointer", fontFamily: "inherit", fontSize: 13, boxSizing: "border-box" }}>← Add More Items</button>
        </>
      )}
    </div>
  );

  // ── CHECKOUT ──────────────────────────────────────────────────────────────────
  const renderCheckout = () => {
    const payOpts = {
      room: ["Cash", "Charge to Room", "Bank Transfer"],
      pickup: ["Cash", "Pay at Pickup", "Bank Transfer"],
      delivery: ["Cash on Delivery", "Bank Transfer"],
    }[orderType] || [];

    return (
      <div style={{ padding: "20px 18px" }}>
        <span style={secLabel}>CHECKOUT DETAILS</span>
        {orderType === "room" && (<><label style={formLabel}>ROOM NUMBER</label><input style={formInput} placeholder="e.g. 204" value={form.room} onChange={(e) => setForm({ ...form, room: e.target.value })} /></>)}
        <label style={formLabel}>YOUR NAME</label>
        <input style={formInput} placeholder="Full name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        {orderType !== "room" && (<><label style={formLabel}>PHONE NUMBER</label><input style={formInput} placeholder="08XXXXXXXXX" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></>)}
        {orderType === "delivery" && (<><label style={formLabel}>DELIVERY ADDRESS</label><input style={formInput} placeholder="Street, area, nearest landmark..." value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} /></>)}
        {orderType === "pickup" && (<><label style={formLabel}>PREFERRED PICKUP TIME</label><input style={formInput} placeholder="e.g. 1:30pm" value={form.pickup} onChange={(e) => setForm({ ...form, pickup: e.target.value })} /></>)}
        <label style={formLabel}>PAYMENT METHOD</label>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 20 }}>
          {payOpts.map((opt) => (
            <button key={opt} onClick={() => setForm({ ...form, payment: opt })}
              style={{ background: form.payment === opt ? C.gold : C.card, border: `1px solid ${form.payment === opt ? C.gold : C.border}`, borderRadius: 8, padding: "10px 14px", color: form.payment === opt ? C.bg : C.cream, fontSize: 12, cursor: "pointer", fontFamily: "inherit", fontWeight: form.payment === opt ? "bold" : "normal" }}>
              {opt}
            </button>
          ))}
        </div>

        {/* Order summary */}
        <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 14, padding: "16px 18px", marginBottom: 16 }}>
          <div style={{ fontSize: 10, letterSpacing: 3, color: C.gold, marginBottom: 10 }}>ORDER SUMMARY</div>
          {cart.map((c) => (
            <div key={c.id} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, color: C.muted, marginBottom: 6 }}>
              <span>{c.name} ×{c.qty}</span><span style={{ color: C.cream }}>{fmt(c.price * c.qty)}</span>
            </div>
          ))}
          {deliveryFee > 0 && <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, color: C.muted, marginBottom: 6 }}><span>Delivery</span><span style={{ color: C.cream }}>{fmt(deliveryFee)}</span></div>}
          <div style={{ display: "flex", justifyContent: "space-between", borderTop: `1px solid ${C.border}`, paddingTop: 10, marginTop: 6 }}>
            <span style={{ fontWeight: "bold" }}>Grand Total</span>
            <span style={{ fontWeight: "bold", fontSize: 18, color: C.gold }}>{fmt(grandTotal)}</span>
          </div>
        </div>

        {/* WhatsApp order button */}
        <button
          onClick={() => {
            if (!form.name || !form.payment) return alert("Please enter your name and select a payment method.");
            if (orderType === "room" && !form.room) return alert("Please enter your room number.");
            if (orderType === "delivery" && !form.address) return alert("Please enter your delivery address.");
            sendToWhatsApp();
          }}
          style={{ display: "block", width: "100%", background: sending ? "#1a8a40" : "#25D366", border: "none", borderRadius: 12, padding: "16px", fontSize: 15, fontWeight: "bold", color: "#fff", cursor: "pointer", letterSpacing: 0.5, fontFamily: "inherit", transition: "background 0.2s" }}>
          {sending ? "⏳ Opening WhatsApp..." : `📲 Place Order via WhatsApp · ${fmt(grandTotal)}`}
        </button>
        <p style={{ textAlign: "center", fontSize: 10, color: C.muted, marginTop: 10, letterSpacing: 1 }}>
          Your order goes directly to the kitchen on WhatsApp
        </p>
      </div>
    );
  };

  // ── CONFIRM ───────────────────────────────────────────────────────────────────
  const renderConfirm = () => (
    <div style={{ padding: 32, textAlign: "center" }}>
      <div style={{ fontSize: 64, marginBottom: 12 }}>✅</div>
      <div style={{ fontFamily: "inherit", fontSize: 28, fontWeight: "bold", color: C.gold, marginBottom: 8 }}>Order Sent!</div>
      <div style={{ fontSize: 11, color: C.muted, letterSpacing: 3, marginBottom: 12 }}>ORDER NUMBER</div>
      <div style={{ background: C.card, border: `1px solid ${C.gold}44`, borderRadius: 14, padding: "16px 28px", fontSize: 26, fontWeight: "bold", color: C.gold, letterSpacing: 4, display: "inline-block", marginBottom: 20 }}>{orderNum}</div>

      {/* WhatsApp sent notice */}
      <div style={{ background: "#25D36618", border: "1px solid #25D36644", borderRadius: 14, padding: "14px 18px", marginBottom: 20 }}>
        <div style={{ fontSize: 22, marginBottom: 6 }}>📲</div>
        <div style={{ color: "#25D366", fontWeight: "bold", fontSize: 14, marginBottom: 4 }}>WhatsApp notification sent to kitchen</div>
        <div style={{ color: C.muted, fontSize: 12 }}>The kitchen has received your full order details and will start preparing immediately.</div>
      </div>

      <div style={{ color: C.muted, fontSize: 14, lineHeight: 1.7, marginBottom: 20 }}>
        {orderType === "room" ? `Your order is being prepared and will be delivered to Room ${form.room}. Estimated: 20–30 mins.`
          : orderType === "pickup" ? `Your food is being prepared. Come pick it up at the kitchen${form.pickup ? ` around ${form.pickup}` : ""}. We'll call if ready sooner.`
            : `Your order is on its way to ${form.address}. Our rider will contact you on ${form.phone}. Estimated: 30–45 mins.`}
      </div>

      {/* Summary */}
      <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 14, padding: 18, textAlign: "left", marginBottom: 20 }}>
        <div style={{ fontSize: 10, letterSpacing: 3, color: C.gold, marginBottom: 12 }}>ORDER SUMMARY</div>
        {cart.map((c) => (
          <div key={c.id} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, color: C.muted, marginBottom: 6 }}>
            <span>{c.name} ×{c.qty}</span><span style={{ color: C.cream }}>{fmt(c.price * c.qty)}</span>
          </div>
        ))}
        {deliveryFee > 0 && <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, color: C.muted, marginBottom: 6 }}><span>Delivery</span><span style={{ color: C.cream }}>{fmt(deliveryFee)}</span></div>}
        <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: 10, marginTop: 6, display: "flex", justifyContent: "space-between", fontWeight: "bold" }}>
          <span style={{ color: C.cream }}>Total Paid</span>
          <span style={{ color: C.gold, fontSize: 18 }}>{fmt(grandTotal)}</span>
        </div>
      </div>

      <p style={{ color: C.muted, fontSize: 12, marginBottom: 16 }}>Questions? Call reception or WhatsApp the kitchen.</p>
      <button onClick={() => { setPage("home"); setCart([]); setForm({ room: "", name: "", phone: "", address: "", pickup: "", payment: "" }); }}
        style={{ background: "transparent", border: `1px solid ${C.border}`, borderRadius: 10, padding: "12px 24px", color: C.muted, cursor: "pointer", fontFamily: "inherit", fontSize: 13 }}>
        ← Place Another Order
      </button>
    </div>
  );

  // ── LAYOUT ────────────────────────────────────────────────────────────────────
  const backDest = { menu: "home", cart: "menu", checkout: "cart" };

  return (
    <div style={base}>
      <NavBar title="Food Ordering" />
      <style>{`@media(min-width:768px){.pb{max-width:720px;margin:0 auto}.cr{display:grid!important;grid-template-columns:repeat(auto-fill,minmax(170px,1fr))!important}}`}</style>
      {/* Header */}
      <div style={{ background: C.surface, borderBottom: `1px solid ${C.border}`, padding: "14px 18px", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100 }}>
        <div>
          <img src={LOGO} style={{height:38,objectFit:"contain",display:"block",marginBottom:2}} alt="The 401 Hotel &amp; Suites Ltd" />
          <div style={{ fontSize: 10, color: C.muted, letterSpacing: 2 }}>
            {orderType ? (orderType === "room" ? "• Room Service" : orderType === "pickup" ? "• Pickup" : "• Delivery") : "• Select order type below"}
          </div>
        </div>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          {page !== "home" && page !== "confirm" && (
            <button onClick={() => setPage(backDest[page] || "home")}
              style={{ background: "transparent", border: `1px solid ${C.border}`, borderRadius: 8, padding: "7px 12px", color: C.muted, cursor: "pointer", fontSize: 12, fontFamily: "inherit" }}>← Back</button>
          )}
          {cartCount > 0 && !["cart", "checkout", "confirm"].includes(page) && (
            <button onClick={() => setPage("cart")}
              style={{ background: `linear-gradient(135deg,${C.gold},${C.goldLight})`, border: "none", borderRadius: 20, padding: "7px 14px", color: C.bg, fontWeight: "bold", cursor: "pointer", fontSize: 13, display: "flex", alignItems: "center", gap: 6, fontFamily: "inherit" }}>
              🛒 {cartCount} · {fmt(cartTotal)}
            </button>
          )}
        </div>
      </div>

      {/* Pages */}
      <div style={{ paddingBottom: 100 }}>
        {page === "home" && renderHome()}
        {page === "menu" && renderMenu()}
        {page === "cart" && renderCart()}
        {page === "checkout" && renderCheckout()}
        {page === "confirm" && renderConfirm()}
      </div>

      {/* Floating cart */}
      {cartCount > 0 && page === "menu" && (
        <button onClick={() => setPage("cart")}
          style={{ position: "fixed", bottom: 20, left: "50%", transform: "translateX(-50%)", background: `linear-gradient(135deg,${C.gold},${C.goldLight})`, borderRadius: 30, padding: "14px 28px", display: "flex", alignItems: "center", gap: 10, boxShadow: `0 8px 32px ${C.gold}44`, cursor: "pointer", zIndex: 200, border: "none", color: C.bg, fontFamily: "inherit", fontSize: 14, fontWeight: "bold", whiteSpace: "nowrap" }}>
          🛒 {cartCount} item{cartCount > 1 ? "s" : ""} &nbsp;·&nbsp; {fmt(cartTotal)} &nbsp;→ View Cart
        </button>
      )}
      {/* Quick Order Type Modal */}
      {showModal && (
        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "#000000aa", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
          <div style={{ background: "#1a1206", border: "1px solid #c8860a44", borderRadius: 20, padding: 28, maxWidth: 340, width: "100%" }}>
            <div style={{ fontSize: 22, textAlign: "center", marginBottom: 8 }}>🍽️</div>
            <div style={{ fontSize: 16, fontWeight: "bold", color: "#f0e4c8", textAlign: "center", marginBottom: 6 }}>How would you like it?</div>
            <div style={{ fontSize: 12, color: "#8a7050", textAlign: "center", marginBottom: 20 }}>
              {pendingItem && pendingItem.name}
            </div>
            {[
              { type: "room", icon: "🛎️", label: "Room Service", desc: "Delivered to your room" },
              { type: "pickup", icon: "🏃", label: "Pickup", desc: "Collect at the kitchen" },
              { type: "delivery", icon: "🛵", label: "Delivery", desc: "Sent to your location" },
            ].map(({ type, icon, label, desc }) => (
              <button key={type} onClick={() => selectTypeAndAdd(type)}
                style={{ display: "flex", alignItems: "center", gap: 14, width: "100%", background: "#0a0702", border: "1px solid #2a1e08", borderRadius: 12, padding: "14px 16px", color: "#f0e4c8", cursor: "pointer", marginBottom: 10, fontFamily: "inherit", textAlign: "left" }}>
                <span style={{ fontSize: 24 }}>{icon}</span>
                <span>
                  <span style={{ display: "block", fontWeight: "bold", fontSize: 14 }}>{label}</span>
                  <span style={{ display: "block", fontSize: 11, color: "#8a7050", marginTop: 2 }}>{desc}</span>
                </span>
              </button>
            ))}
            <button onClick={() => { setShowModal(false); setPendingItem(null); }}
              style={{ width: "100%", background: "transparent", border: "1px solid #2a1e08", borderRadius: 10, padding: "10px", color: "#8a7050", cursor: "pointer", fontFamily: "inherit", fontSize: 13, marginTop: 4 }}>
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
